import { render, staticRenderFns } from "./ViewNotFound.vue?vue&type=template&id=6ffa48d0&scoped=true"
import script from "./ViewNotFound.vue?vue&type=script&lang=js"
export * from "./ViewNotFound.vue?vue&type=script&lang=js"
import style0 from "./ViewNotFound.vue?vue&type=style&index=0&id=6ffa48d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa48d0",
  null
  
)

export default component.exports